import { DropdownIcon, LongArrowIcon, Typography } from '@libs/components';
import { BigDropdownIcon } from 'src/assets';
import { useTranslation } from 'src/hooks';
import { useTheme } from 'styled-components';
import {
  ArrowWrapper,
  Container,
  CustomArrowIcon,
  CustomImg,
  IconWrapper,
  InsideContainer,
  Separator,
  TittleWrapper,
} from './styles';

type TransactionDetailsHeaderProps = {
  title: string;
  assetIcone?: string;
  operationTitle?: string;
  assetCode?: string;
  amount?: string;
  toAssetIcone?: string;
  toAssetCode?: string;
  toAmount?: string;
};

export const TransactionDetailsHeader: React.FC<
  TransactionDetailsHeaderProps
> = ({
  title,
  assetIcone,
  assetCode,
  amount,
  operationTitle,
  toAssetIcone,
  toAssetCode,
  toAmount,
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <Container>
      <TittleWrapper>
        <Typography type="subHeadline" fontFamily="primaryBold">
          {title}
        </Typography>
      </TittleWrapper>
      <InsideContainer showSeparator={!!toAssetCode}>
        <IconWrapper>
          <CustomImg src={assetIcone} />
        </IconWrapper>
        <Typography
          type="bodyButton"
          fontFamily="primaryMedium"
          color={colors.text.secondary}
        >
          {operationTitle}
        </Typography>
        <Typography type="subHeadline" fontFamily="primaryBold">
          {amount + ' '} {assetCode}
        </Typography>
      </InsideContainer>
      {toAssetCode && (
        <ArrowWrapper>
          <CustomArrowIcon />
        </ArrowWrapper>
      )}
      {/* {toAssetCode && <Separator />} */}
      {toAssetCode && (
        <InsideContainer>
          <IconWrapper>
            <CustomImg src={toAssetIcone} />
          </IconWrapper>
          <Typography
            type="bodyButton"
            fontFamily="primaryMedium"
            color={colors.text.secondary}
          >
            {t('common_recived')}
          </Typography>
          <Typography type="subHeadline" fontFamily="primaryBold">
            {toAmount + ' '} {toAssetCode}
          </Typography>
        </InsideContainer>
      )}
    </Container>
  );
};
export default TransactionDetailsHeader;
